import React from "react";
import { connect } from "react-redux";
import { socket } from "../src/constants/actionTypes";
import { toast } from "react-toastify";
import Routers from "./Routers";
import moment from "moment";
import "moment-timezone";
import TopBar from "./component/Constant/TopBar";
import { AutoLogoutProvider } from "./AutoLogout/AutoLogoutContext";
import "./AutoLogout.css"
 
const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
const schoolName = user_info?.user_school?.actual_school_code;
console.log(user_info?.user_school?.school_logo, "currentUserInfocurrentUserInfo");
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permission_checked: true,
      socket_called: 0,
      avatar_updated: 0, // Track avatar updates to trigger re-renders
      school_logo_updated: 0, // Track school logo updates to trigger re-renders
    };
  }
  componentDidMount() {
    socket.on("new-notification", (resp) => {
      console.log("socket", resp);
      let session_title;
      if (resp.attendance_title) {
        session_title = resp.attendance_title;
      } else {
        session_title = "Snapshot";
      }
      const current = new Date(resp.created_date);
      const timezone = user_info?.user_school?.timezone;
      const time = moment(current)?.tz(timezone)?.format("MMMM Do YYYY, h:mm a");
      let counting = this.state.socket_called;
      this.setState({ socket_called: counting + 1 });
      console.log("response 11 of notification in socket.on", resp);
      if (resp.school_code === schoolName) {
        toast.warning(
          ` ${resp.student_first_name} ${resp.student_last_name} from ${resp.dormitory_name}  has been listed as MIA by ${resp.user_name} at ${time} via ${session_title}`,
          { position: toast.POSITION.BOTTOM_RIGHT }
        );
      }
    });
    // Listen for profile updates
    socket.on("update_manager_profile", (data) => {
      console.log("Profile update received:", data);
      
      if (data && data.avatar_url) {
        // Get current user info from localStorage
        const currentUserInfo = JSON.parse(localStorage.getItem("bss_authuser"));
        
        if (currentUserInfo) {
          // Update the avatar in the user info object
          currentUserInfo.avatar = data.avatar_url;
          
          // Save updated user info back to localStorage
          localStorage.setItem("bss_authuser", JSON.stringify(currentUserInfo));
          
          // Update state to trigger re-render
          this.setState({ avatar_updated: this.state.avatar_updated + 1 });
          
          // Optional: Show a toast notification
          // toast.info("Profile picture updated successfully!", {
          //   position: toast.POSITION.BOTTOM_RIGHT
          // });
          
          console.log("Avatar updated to:", data.avatar_url);
        }
      }
    });
    socket.on("update_school_profile", (data) => {
      console.log("School profile update received:", data);
      
      if (data && data.avatar_url) {
        // Get current user info from localStorage
        const currentUserInfo = JSON.parse(localStorage.getItem("bss_authuser"));
        
        if (currentUserInfo && currentUserInfo.user_school) {
          // Update the school logo in the user info object
          currentUserInfo.user_school.school_logo = data.avatar_url;
          
          // Save updated user info back to localStorage
          localStorage.setItem("bss_authuser", JSON.stringify(currentUserInfo));
          
          // Update state to trigger re-render
          this.setState({ school_logo_updated: this.state.school_logo_updated + 1 });
          
          // Optional: Show a toast notification
          // toast.info("School logo updated successfully!", {
          //   position: toast.POSITION.BOTTOM_RIGHT
          // });
          
          console.log("School logo updated to:", data.avatar_url);
        }
      }
    });
  }
  componentWillUnmount() {
    // Clean up socket listeners
    socket.off("new-notification");
    socket.off("update_manager_profile");
    socket.off("update_school_profile");
  }
  render() {
    console.log("Count", this.state.socket_called);
    localStorage.setItem(
      "Socket_calls",
      JSON.stringify(this.state.socket_called)
    );
    if (this.state.permission_checked === false) {
      return null;
    }
    return (
      <div className="App">
        <AutoLogoutProvider>
          <Routers key={`${this.state.avatar_updated}-${this.state.school_logo_updated}`} />
        </AutoLogoutProvider>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {};
}
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(App);